<template>
  <section class="news-container">
    <div class="content-full-width flex">

      <button class="button small button-filter" :class="{ 'active': toggleFilter }" 
        @click="toggleFilter = !toggleFilter"
      >
        <span v-if="toggleFilter">HIDE</span>
        <span>FILTERS</span>
      </button>

      <aside class="filter-sidebar" :class="{ 'active': toggleFilter }">
        <div class="category">

          <div class="archive">
            <label>Archive</label>

            <a 
                :href="link.url"
                v-for="(link, index) of archives" :key="index"
                v-if="index < archiveShow"
            >
                {{ link.label }} <span>({{ link.count }})</span>
            </a>

            <button class="toggle"
              v-if="archives.length > archiveShow"
              @click="archiveShow = archives.length"
            >
                Show More
            </button>

          </div>

        </div>
      </aside>

      <div class="news-list">
      
        <div class="form-field text search">
          <label>Search</label>
          <input type="text"
            placeholder="Start typing..." 
            v-model="payload.keyword" v-debounce:750ms="loadStories"
          >
        </div>

        <div class="results">
        
          <article v-for="article of stories" :key="article.id">
            <a :href="article.url" class="image">
              <img
                v-if="article.image !== null" 
                :src="article.image"
                :alt="'Habit Health ' + article.title"
              >
              <div class="backup" v-else>
                <img src="/images/logo-mark.svg" :alt="'Habit Health ' + article.title" >
              </div>
            </a>
            <div class="content">
              <h3>{{ article.title }}</h3>
              <p class="date">{{ article.published_date }}</p>

              <div class="tags">
                <span class="icon icon-tag"></span>
                <a v-for="(tag, index) of article.module_groups_items[0].items"
                  :href="'?tag='+tag.id"
                >
                  {{ tag.title }}<i v-if="article.module_groups_items[0].items.length !== index+1">,</i>  
                </a>
              </div>

              <div class="description">
                <p>{{ article.blurb }}</p>
              </div>
            </div>
          </article>
        
        </div>

        <div class="pagination-module">

          <b-pagination class="pagination"
            v-if="meta.total > 5"
            v-model="meta.current_page"
            :total-rows="meta.total"
            :per-page="meta.per_page"
            @input="pageLoad(meta.current_page)"
          >
            <template v-slot:first-text><span class="icon icon-angle-left"></span></template>
            <template v-slot:page="{ page, active }" :class="{ 'active': active }">
              {{ page }}
            </template>
            <template v-slot:last-text><span class="icon icon-angle-right"></span></template>
          </b-pagination>

        </div>

      </div>

    </div>
  </section>
</template>

<script>
export default {
  props: {
    archives: Array,
    module_type: Number,
    search_url: String
  },
  data () {
    return {
      toggleFilter: false,
      archiveShow: 4,
      payload: {
        module_type: this.module_type,
        page: 1,
        per_page: 5,
        keyword: '',
        date: '',
        group_items: []
      },
      stories: [],
      meta: {
        current_page: 1,
        per_page: 5,
        total: 5

      }
    };
  },
  mounted () {
    if (window.location.search) {
      let date = window.location.search.split('date=')[1]
      if (date) {
        this.payload.date = date
      }

      let tag_id = window.location.search.split('tag=')[1]
      if (tag_id) {
        this.payload.group_items.push(tag_id)
      }
    }

    this.loadStories()
  },
  methods: {
    pageLoad (page) {
      this.payload.page = page
      this.loadStories()
    },

    loadStories () {
      this.$store.commit('setLoading', true)
      this.stories = []
      this.payload.page = this.meta.current_page

      if (this.tag) {
        this.payload.group_items = [this.tag]
      }
      
      window.axios.post(this.search_url, this.payload)
        .then((response) => {
          this.$store.commit('setLoading', false)
          this.stories = response.data.data
          this.meta = response.data.meta
        })
        .catch((error) => {
          console.log('prodd error', error)
          this.$store.commit('setLoading', false)
          this.$store.commit('setPopup', {
            content: '<p>Sorry, the stories could not be loaded.</p>',
            open: true
          })
        })
    },

    sortDate (date) {
      var arrayOfNumbers = date.split(/T|:|-/).map(Number);
      let sortedDate = arrayOfNumbers[1] + '-' + arrayOfNumbers[0] + '-' + arrayOfNumbers[2]
      console.log(sortedDate)
      return this.$date(sortedDate).format('DD MMM YYYY')
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/client-stories/Index.vue